export default "__VITE_ASSET__DiLGu4Lx__"